
const state = {
  runningOnElectron: false,
  ipcRenderer: null
};

const mutations = {
  SET_RUNNING_ON_ELECTRON(state, data) {
    state.runningOnElectron = data;
  },
  SET_IPC_RENDERER(state, data) {
    state.ipcRenderer = data;
  }
};

const actions = {

  initializeIPC({ commit, dispatch }) {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf(" electron/") > -1) {
      commit("SET_RUNNING_ON_ELECTRON", true);
      commit("SET_IPC_RENDERER", window.ipcRenderer);

      // eslint-disable-next-line no-unused-vars
      state.ipcRenderer.on("app-loaded-reply", (event, arg) => {
        const creds = {
          email: arg.email,
          password: arg.password,
          pid: arg.pid
        };

        dispatch("connect", creds);
      });
      if (state.runningOnElectron) {
        
        // eslint-disable-next-line no-unused-vars
        state.ipcRenderer.on("realtime-control-reply", (event, arg) => {
          dispatch("updateRealtimeControlData", arg.data);
        });
      }

      state.ipcRenderer.send("app-loaded", { app: "virtual" });
    }
  },
  videoStarted({ state, rootGetters }) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("playback", {
        app: "virtual",
        status: "started",
        details: {
          video: rootGetters.getCurrentVideo.name,
          duration: rootGetters.getCurrentVideo.duration,
          color: rootGetters.getCurrentVideo.color
        }
      });
    }
  },
  videoStopped({ state, rootGetters }) {
    if (state.runningOnElectron) {
      const data = {
        app: "virtual",
        status: "stopped",
        details: {}
      };
      if (
        rootGetters.getPlayer.lights !== undefined &&
                rootGetters.getPlayer.lights.ambientLightColor !== undefined
      ) {
        data.details.color = rootGetters.getPlayer.lights.ambientLightColor;
      }
      state.ipcRenderer.send("playback", data);
    }
  },
  setLightScene({ state }, color) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("set-light-scene", {
        app: "virtual",
        color
      });
    }

  },
  setLightShow({ state }, data) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("set-light-show", {
        app: "virtual",
        color: data.color,
        value: data.value
      });
    }
  },
  setInstructorLight({ state }, lightStateOn) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("set-instructor-light", {
        app: "virtual",
        on: lightStateOn
      });
    }
  },
  controlDisplay({ state }, command) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("control", { app: "virtual", device: "display", command });
    }
  },
  sendTimeEvent({ state }, { videoName, videoTime }) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("time-event", { app: "virtual", videoName, videoTime });
    }
  },
  startStreaming({ state, rootGetters }) {
    if (state.runningOnElectron) {

      const settings = {
        url: `rtmp://${rootGetters.getLivechannel.wowzaServer}:1935/${rootGetters.getLivechannel.wowzaApp}`,
        streamUser: rootGetters.getLivechannel.streamUser,
        streamPassword: rootGetters.getStreamingPassword,
        streamName: rootGetters.getNextEvent.streamName,
      };

      state.ipcRenderer.send("streaming", {
        app: "virtual",
        command: "start",
        settings,
        duration: parseInt(rootGetters.getNextEvent.duration),
        color: rootGetters.getNextEvent.color
      });
    }
  },
  stopStreaming({ state }) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("streaming", { app: "virtual", command: "stop" });
    }
  },
  realtimeControl({ state }, data) {
    if (state.runningOnElectron) {
      state.ipcRenderer.send("realtime-control", {
        app: "virtual",
        data,
      });
    }
  }


};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/IPC.js